export default __webpack_public_path__ + "assets/ned.b0544c2d.png";